module.exports = __webpack_public_path__ + "media/images/flags/1x1/ken-cec45f301019f91f33dc704031f6905b.svg";